<template>
  <div>
    <b-modal 
      centered 
      id="ModalDownLoadFormats"
      modal-class="dialog-600"
      hide-footer
      :title="$t('Descargar formato')"
      @close="close"
      no-close-on-esc
      no-close-on-backdrop
    >
      <form-render ref="formModalDownLoadFormats" :form="form" :fields="fields" containerButtonsClass="col-sm-4 mt-2" :key="keyFormRender" ></form-render>
      <div class="footer-modal-custom-coverage">
        <b-button class="float-right mt-1 mb-1" variant="outline-success" @click="ok" :disabled="loading.downloadFile">
          <span v-if="!loading.downloadFile" class="mb-1">Descargar</span>
          <span class="mt-1 p-2" v-if="loading.downloadFile"><b-spinner small  /> </span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import BaseServices from '@/store/services/index'
import { mapGetters } from 'vuex'

export default {
  name: 'ModalDownLoadFormats',
  props: ['data'],
  data() {
    return {
      form: {},
      fields: [],
      keyFormRender: 0,
      baseService: new BaseServices(this),
      fieldOrigin: { fieldType: 'FieldSelect', label: 'Origen', useLabel: true, name: 'origin', validation: 'required', containerClass: 'col-12 fieldSelect', clearable: true, searchOnType: { fx: this.setPlaces, nChars: 3, debounce: 600 }, sort: true},
      fieldPriceRange: { fieldType: 'FieldInput', name: 'priceRange', label: 'Máximo de kg', type: 'number', min: 0, max: 1000, containerClass: 'col-sm-12 container-info mt-1', validation: 'required', aditionalLabel: {type: 'primary', text: '(hasta cuántos kilos se cargará la tarifa sin aplicar un valor por kg adicional).'}, append: {text:  'Hasta'}, placeholder: 'Ingrese la cantidad máxima'},
      fieldPriceFactor: { fieldType: 'FieldInput', name: 'priceFactor', label: 'Máximo de kg para valor adicional ', type: 'number', min: 0, max: 100000, containerClass: 'col-sm-12 container-info', aditionalLabel: {type: 'primary', text: '(hasta cuántos kilos se aplicará un valor por kg adicional).'}, textHelp: {text: 'Ingrese un valor mayor o igual al máximo de kg sin valor adicional (definido en el segundo campo).', icon: 'InfoIcon'}, append: {text:  'Hasta'}, placeholder: 'Ingrese la cantidad máxima'},
      loading: {
        downloadFile: false
      }
    }
  },
  methods: {
    setInitialData() {
      this.fields = [
        this.fieldOrigin,
        this.fieldPriceRange,
        this.fieldPriceFactor
      ]
    },
    async setPlaces(value) {
      const queryParams = {search: value}
      const params = {country_id: this.data.form.country.id}
      return await this.baseService.callService('getPlacesFullLevelSearchByCountry', queryParams, params)
        .then(resp => { 
          return resp.data.places.map(el => ({...el, text: el.full_name}))
        })
        .catch(err => { return err })
    },
    setQueryParams() {
      const queryParams = {}
      if (this.data.form.country.code === 'CL') {
        queryParams.origin_comuna = this.form.origin.name
        queryParams.destination_comunas = ['todas']
      } else if (this.data.form.country.code === 'CO') {
        queryParams.origin_centro_poblado = `${this.form.origin.code}`
        queryParams.destination_centros_poblados = ['todas']
      } else if (this.data.form.country.code === 'PE') {
        queryParams.origin_distrito = `${this.form.origin.code}`
        queryParams.destination_distritos = ['todas']
      } else if (this.data.form.country.code === 'MX') {
        queryParams.origin_codigo_postal = `${this.form.origin.code}`
        queryParams.destination_codigos_postales = ['todas']
      }
      if (this.form.priceRange) queryParams.price_range = parseInt(this.form.priceRange)
      if (this.form.priceFactor) queryParams.price_factor = parseInt(this.form.priceFactor)
      return queryParams
    },
    async ok (e) {
      e.preventDefault()
      const check = await this.$refs.formModalDownLoadFormats.onlyCheckForm()
      if (check) this.sendForm()
    },
    sendForm() {
      this.loading.downloadFile = true
      const params = {country_id: this.data.form.country.id}
      const queryParams = this.setQueryParams()
      const props = {
        name: 'postGenerateCustomFile',
        params,
        fileName: `Formato_archivo_carga_${this.data.form.country.name}`,
        showToast:  true,
        queryParams,
        onSuccess: this.close,
        onError: () => { this.loading.downloadFile = false }
      }
      this.$store.dispatch('fetchServiceGenerateExcel', props)
    },
    close() {
      this.loading.downloadFile = false
      this.form = {}
      this.$bvModal.hide('ModalDownLoadFormats')
    }
  }
}
</script>